export class DialogModelConfirmSingleSOCancel {
    constructor(
      public order: any
    ) {}
  }
  